var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43417 15.8125C10.2298 14.6359 10.3031 13.3652 9.65411 12.0002C9.47364 12.7325 9.14352 13.1769 8.66371 13.3336C9.10927 12.0611 8.73696 10.6864 7.54674 9.20934C7.52105 10.7348 7.15446 11.8461 6.44692 12.5431C5.47224 13.5024 5.48371 14.585 6.4813 15.791C2.34011 13.5872 1.75586 10.6314 4.72849 6.92381C4.91286 7.8195 5.35964 8.36941 6.06889 8.57353C5.2958 5.29287 6.10921 2.49753 8.50908 0.1875C8.52383 5.31397 10.0959 5.76963 12.0835 8.05797C14.2295 10.8041 12.9683 13.9732 9.43417 15.8125Z",
    fill: "#283E24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire1);
export default __webpack_public_path__ + "static/media/fire 1.5c9a833669bdcf71b56d0729f9b59ef0.svg";
export { ForwardRef as ReactComponent };